import LinkButton from '~/components/button/LinkButton';
import Submit from '~/components/button/Submit';
import CardSection from '~/components/CardSection';
import CustomerInfoDisplay from '~/components/CustomerInfoDisplay';
import Page from '~/components/layout/page/Page';
import { useIsLoading } from '~/utils/routing';
import { useLoaderData } from './addressReview';

export default function AddressReviewPage() {
  const { customerInfo, nextStep } = useLoaderData();
  const isLoading = useIsLoading();

  return (
    <Page.Root title="Confirm Address">
      <CardSection action={<LinkButton to="edit">Update</LinkButton>}>
        <CustomerInfoDisplay info={customerInfo} />
      </CardSection>
      {isLoading ? (
        <Submit loading>Next</Submit>
      ) : (
        <LinkButton to={nextStep} variant="filled" className="w-full md:w-1/2">
          Next
        </LinkButton>
      )}
    </Page.Root>
  );
}
